import { render, staticRenderFns } from "./ShippoDimensionsShouldConvert.vue?vue&type=template&id=08d2b186&"
import script from "./ShippoDimensionsShouldConvert.vue?vue&type=script&lang=ts&"
export * from "./ShippoDimensionsShouldConvert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports